<template>
  <div>
    <v-card
      :width="700"
      color="#f2f7fb"
      id="compareMenu"
      style="
        cursor: move;
        user-select: none;
        position: absolute;
        top: 48px;
        left: 460px;
        z-index: 9999;
        border: 1px solid #2c3e50;
        border-radius: 8px f;
      "
    >
      <v-card-text>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("global.concepts.file") + " 1" }}
              </v-list-item-title>

              <v-list-item-subtitle v-if="$store.state.comparingFileVersion1">
                <v-row dense>
                  <v-col style="font-weight: bold; text-align: left" cols="2">
                    {{ $t("global.concepts.name") }}
                  </v-col>

                  <v-col cols="auto">
                    {{ $store.state.comparingFileVersion1.name }}
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col style="font-weight: bold; text-align: left" cols="2">
                    {{ $t("global.concepts.version") }}
                  </v-col>

                  <v-col cols="auto">
                    {{ $store.state.comparingFileVersion1.version }}
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col style="font-weight: bold; text-align: left" cols="2">
                    {{ $t("global.environment.environment") }}
                  </v-col>
                  <v-col cols="auto">
                    <v-chip
                      small
                      outlined
                      v-if="$store.state.comparingFileVersion1?.fileEnvIsLocal"
                    >
                      LOCAL
                    </v-chip>
                    <file-env-chip
                      v-if="!$store.state.comparingFileVersion1?.fileEnvIsLocal"
                      :color="$store.state.comparingFileVersion1?.fileEnvColor"
                      :label="$store.state.comparingFileVersion1?.fileEnvLabel"
                    >
                    </file-env-chip>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>

              <v-list-item-subtitle v-else>
                {{ $t("global.concepts.no-file-selected") }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-icon>
              <v-btn icon v-if="$store.state.comparingFileVersion1?.id">
                <v-icon color="error" @click="unsetVersion1">
                  pic-delete
                </v-icon>
              </v-btn>
            </v-list-item-icon>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("global.concepts.file") + " 2" }}
              </v-list-item-title>

              <v-list-item-subtitle v-if="$store.state.comparingFileVersion2">
                <v-row dense>
                  <v-col style="font-weight: bold; text-align: left" cols="2">
                    {{ $t("global.concepts.name") }}
                  </v-col>
                  <v-col cols="auto">
                    {{ $store.state.comparingFileVersion2.name }}
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col style="font-weight: bold; text-align: left" cols="2">
                    {{ $t("global.concepts.version") }}
                  </v-col>
                  <v-col cols="auto">
                    {{ $store.state.comparingFileVersion2.version }}
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col style="font-weight: bold; text-align: left" cols="2">
                    {{ $t("global.environment.environment") }}
                  </v-col>
                  <v-col cols="auto">
                    <v-chip
                      small
                      outlined
                      v-if="$store.state.comparingFileVersion2?.fileEnvIsLocal"
                    >
                      LOCAL
                    </v-chip>
                    <file-env-chip
                      v-if="!$store.state.comparingFileVersion2?.fileEnvIsLocal"
                      :color="$store.state.comparingFileVersion2?.fileEnvColor"
                      :label="$store.state.comparingFileVersion2?.fileEnvLabel"
                    >
                    </file-env-chip>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>

              <v-list-item-subtitle v-else>
                {{ $t("global.concepts.no-file-selected") }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-icon>
              <v-btn icon v-if="$store.state.comparingFileVersion2?.id">
                <v-icon color="error" @click="unsetVersion2">
                  pic-delete
                </v-icon>
              </v-btn>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-if="!isComparing && !isCompared()"
          color="primary"
          :disabled="
            !$store.state.comparingFileVersion1 ||
            !$store.state.comparingFileVersion2
          "
          @click="onCompare"
        >
          {{ $t("global.run.compare") }}
        </v-btn>

        <v-btn v-if="isComparing" color="primary" disabled>
          {{ $t("global.concepts.comparing") }}
        </v-btn>

        <v-btn
          v-if="isCompared() && !maxSizeExceeded"
          @click="onOpenHtml"
          color="primary"
        >
          {{ $t("global.action.view") }}
        </v-btn>

        <v-btn
          v-if="isCompared()"
          @click="onDownloadComparison"
          color="primary"
        >
          {{ $t("global.action.download") }}</v-btn
        >

        <v-btn @click="$emit('close')"> {{ $t("global.action.close") }}</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showComparison" persistent>
      <v-overlay absolute :value="isLoadingComparison">
        <v-chip color="blue" dark>{{ $t("global.msg.loading") }}</v-chip>
      </v-overlay>

      <v-card>
        <v-icon
          large
          @click="onCloseComparison"
          color="error"
          style="float: right"
        >
          mdi-alpha-x-box-outline
        </v-icon>

        <v-card-text>
          <iframe
            :src="comparisonUrl"
            width="100%"
            title="Comparison"
            class="mt-1"
            ref="comparisonHtml"
            style="height: 74vh"
            v-if="showComparison"
            @load="handleComparisonLoaded"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FileEnvChip from "@/components/FileEnvChip";
import { get, downloadFile, getIframeToken } from "@/model/api";

export default {
  name: "FileComparison",

  components: {
    FileEnvChip,
  },

  data() {
    return {
      maxSizeExceeded: false,
      isComparing: false,
      isComparedInt: false,
      comparedVersionId1: undefined,
      comparedVersionId2: undefined,
      isLoadingComparison: false,
      comparisonUrl: "",
      showComparison: false,
      excelFileId1: undefined,
      excelVersionId1: undefined,
      excelFileId2: undefined,
      excelVersion2: undefined,

      active: false,
      initialX: undefined,
      initialY: undefined,
      xOffset: 0,
      yOffset: 0,
      compareItem: undefined,
      cardWidth: undefined,
      cardHeight: undefined,

      viewportWidth: undefined,
      viewportHeight: undefined,

      offsetChannel: new BroadcastChannel("file-comparison-offset"),
      version1Channel: new BroadcastChannel("version1-channel"),
      version2Channel: new BroadcastChannel("version2-channel"),
    };
  },

  methods: {
    unsetVersion1() {
      this.$store.commit("unsetComparingFileVersion1");
      this.version1Channel.postMessage("unset");
    },

    unsetVersion2() {
      this.$store.commit("unsetComparingFileVersion2");
      this.version2Channel.postMessage("unset");
    },

    onCompare() {
      if (
        !this.$store.state.comparingFileVersion1 ||
        !this.$store.state.comparingFileVersion2
      ) {
        return;
      }
      this.isComparing = true;
      const file1 = this.$store.state.comparingFileVersion1;
      const fileId1 = file1.fileId;
      const version1 = file1.version - 1;

      const file2 = this.$store.state.comparingFileVersion2;
      const fileId2 = file2.fileId;
      const version2 = file2.version - 1;

      get(
        `/file/generate-comparison/${fileId1}/${version1}/${fileId2}/${version2}`
      )
        .then((r) => {
          this.maxSizeExceeded = r;
          this.isComparing = false;
          this.comparedVersionId1 = file1.id;
          this.comparedVersionId2 = file2.id;
          this.isComparedInt = true;
        })
        .catch((e) => {
          this.$store.commit("showError", e);
          this.isComparing = false;
        });
    },

    async onOpenHtml() {
      this.isLoadingComparison = true;
      const file1 = this.$store.state.comparingFileVersion1;
      this.excelFileId1 = file1.fileId;
      this.excelVersion1 = file1.version - 1;

      const file2 = this.$store.state.comparingFileVersion2;
      this.excelFileId2 = file2.fileId;
      this.excelVersion2 = file2.version - 1;

      this.showComparison = true;
      try {
        const { token } = await getIframeToken(
          "file/comparison",
          this.excelFileId1,
          this.excelVersion1,
          this.excelFileId2,
          this.excelVersion2
        );
        this.comparisonUrl = `/compliance-server/api/file/comparison-html/${this.excelFileId1}/${this.excelVersion1}/${this.excelFileId2}/${this.excelVersion2}/index.html?iframeToken=${token}`;
      } catch (err) {
        this.$store.commit("showError", err);
        this.isLoadingComparison = false;
      }
    },

    onDownloadComparison() {
      const file1 = this.$store.state.comparingFileVersion1;
      const fileId1 = file1.fileId;
      const version1 = file1.version - 1;

      const file2 = this.$store.state.comparingFileVersion2;
      const fileId2 = file2.fileId;
      const version2 = file2.version - 1;

      downloadFile(
        `/file/download-comparison/${fileId1}/${version1}/${fileId2}/${version2}`
      ).catch((err) => {
        this.$store.commit("showError", err);
      });
    },

    onCloseComparison() {
      this.showComparison = false;

      // Switching tabs in the Excel preview inserts elements into the history stack, so we need to remove these when the preview is closed
      // OOL-2629
      get(
        `/file/comparison-html-sheet-requests/${this.excelFileId1}/${this.excelVersion1}/${this.excelFileId2}/${this.excelVersion2}`
      )
        .then((r) => {
          if (r > 1) {
            window.history.go(-r + 1);
          }
        })
        .catch((err) => this.$store.commit("showError", err));
    },

    handleComparisonLoaded() {
      const iframe = this.$refs.comparisonHtml;
      const pre = iframe.contentDocument.querySelector("body > pre");
      if (pre) {
        const serverError = pre.textContent;
        if (serverError.includes("Max size exceeded")) {
          this.comparisonUrl = "";
          this.$store.commit("showWarning", this.$t("global.msg.fichierGrand"));
        } else if (serverError.includes("File not found or empty")) {
          this.comparisonUrl = "";
          this.$store.commit(
            "showWarning",
            this.$t("global.msg.missingEmptyTemplateFile")
          );
        }
      }
      this.isLoadingComparison = false;
    },

    isCompared() {
      if (
        !this.isComparedInt ||
        !this.comparedVersionId1 ||
        !this.comparedVersionId2
      ) {
        return false;
      }
      const versionId1 = this.$store.state.comparingFileVersion1?.id;
      const versionId2 = this.$store.state.comparingFileVersion2?.id;
      const isCompared =
        this.comparedVersionId1 === versionId1 &&
        this.comparedVersionId2 === versionId2;
      return isCompared;
    },

    dragStart(e) {
      this.initialX = e.clientX - this.xOffset;
      this.initialY = e.clientY - this.yOffset;
      this.active = true;
    },

    drag(e) {
      if (!this.active) return;

      e.preventDefault();

      const newXoffset = e.clientX - this.initialX;
      const newYoffset = e.clientY - this.initialY;

      // Clamp X and Y to keep the card within the viewport
      const left = parseInt(this.compareItem.style.left);
      const right = parseInt(this.compareItem.style.top);
      const minX = -left - this.cardWidth / 2;
      const minY = -right - this.cardHeight / 2;
      const maxX = this.viewportWidth - left - this.cardWidth;
      const maxY = this.viewportHeight - right - this.cardHeight / 2;

      this.xOffset = Math.min(Math.max(newXoffset, minX), maxX);
      this.yOffset = Math.min(Math.max(newYoffset, minY), maxY);

      this.compareItem.style.transform = `translate(${this.xOffset}px, ${this.yOffset}px)`;

      this.offsetChannel.postMessage({ x: this.xOffset, y: this.yOffset });
    },

    dragEnd() {
      this.active = false;

      const newOffset = {
        x: this.xOffset,
        y: this.yOffset,
      };

      this.$store.commit("setFileComparisonOffset", newOffset);

      this.offsetChannel.postMessage(newOffset);
    },
  },

  mounted() {
    this.compareItem = document.getElementById("compareMenu");

    this.compareItem.addEventListener("mousedown", this.dragStart);
    document.addEventListener("mouseup", this.dragEnd);
    document.addEventListener("mousemove", this.drag);

    this.xOffset = this.$store.state.fileComparisonOffset.x;
    this.yOffset = this.$store.state.fileComparisonOffset.y;
    this.compareItem.style.transform = `translate(${this.xOffset}px, ${this.yOffset}px)`;

    const cardRect = this.compareItem.getBoundingClientRect();
    this.cardWidth = cardRect.width;
    this.cardHeight = cardRect.height;

    this.viewportWidth = window.innerWidth;
    this.viewportHeight = window.innerHeight;

    this.offsetChannel.onmessage = (event) => {
      const xTransl = event.data.x;
      const yTransl = event.data.y;
      this.compareItem.style.transform = `translate(${xTransl}px, ${yTransl}px)`;
    };

    this.version1Channel.onmessage = (event) => {
      if (event.data === "unset") {
        this.$store.commit("unsetComparingFileVersion1");
      }
    };

    this.version2Channel.onmessage = (event) => {
      if (event.data === "unset") {
        this.$store.commit("unsetComparingFileVersion2");
      }
    };
  },
};
</script>
